// extracted by mini-css-extract-plugin
module.exports = {"vehicleMassLoad":"styles_vehicleMassLoad__1vVj1","vehiclesForSales":"styles_vehiclesForSales__2upR8","vehicleMassLoadBackButtom":"styles_vehicleMassLoadBackButtom__hbdf7"};